import { useFormContext } from "react-hook-form";
import { FormControl, Input, InputLabel } from "@mui/material";
import { VRSTA_OPERATERA } from "../../../../enums";
import { PorukaGreskePolja } from "../../../index";
import daLiJePoljeValidno from "../../../../utils/daLiJePoljeValidno";
import { ChangeEvent } from "react";

const Index = ({ disabled }: { disabled?: boolean }) => {
  const { register, getValues, setValue, watch } = useFormContext();
  const vrstaOperatera = parseInt(
    getValues("operaterPlatforme.vrstaOperatera.id")
  );
  const value = watch("operaterPlatforme.primarniIdentifikator.vrijednost");
  return (
    <FormControl
      fullWidth
      error={
        !daLiJePoljeValidno(
          "operaterPlatforme.primarniIdentifikator.vrijednost"
        ) || !daLiJePoljeValidno("operaterPlatforme.primarniIdentifikator")
      }
    >
      <InputLabel htmlFor="operaterPlatforme.primarniIdentifikator.vrijednost">
        {vrstaOperatera === VRSTA_OPERATERA.IZ_RH
          ? "*Primarni identifikator - OIB (Primary identifier - OIB)"
          : "*Primarni identifikator - TIN (Primary identifier - TIN)"}
      </InputLabel>
      <Input
        value={value || ""}
        disabled={disabled}
        aria-describedby="primarni identifikator"
        inputProps={{
          maxLength: vrstaOperatera === VRSTA_OPERATERA.IZ_RH ? 11 : null,
        }}
        {...register("operaterPlatforme.primarniIdentifikator.vrijednost")}
      />
      <PorukaGreskePolja
        nazivPolja={"operaterPlatforme.primarniIdentifikator.vrijednost"}
      />
      <PorukaGreskePolja
        nazivPolja={"operaterPlatforme.primarniIdentifikator"}
      />
    </FormControl>
  );
};

export default Index;
